import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CustomersDataService {
  private apiUrl = environment.WS_URL + '/api/v1/coffee/customers';

  constructor(private http: HttpClient) { }

  getCustomers(): Observable<any> {
    return this.http.get<any>(this.apiUrl);
  }
  
  getCustomer(id: number): Observable<any> {
    return this.http.get<any>(this.apiUrl + '/' + id);
  }

  getTraders(): Observable<any> {
    return this.http.get<any>(environment.WS_URL + '/api/v1/coffee/traders');
  }

  getTrader(id: number): Observable<any> {
    return this.http.get<any>(environment.WS_URL + '/api/v1/coffee/traders/' + id);
  }

  postData(data: any): Observable<any> {
    return this.http.post<any>(this.apiUrl, data);
  }
}
